module.exports = __webpack_public_path__ + "img/34.127e126e.jpg";